import React from "react";
import "./Investor3thing.css";

import { motion } from "framer-motion";
import investoricon1 from "../../img/investors/investoricon1.png";
import investoricon2 from "../../img/investors/investoricon2.png";
import investoricon3 from "../../img/investors/investoricon3.png";

function Investor3thing() {
  const fadeInUp = {
    hidden: { opacity: 1, y: 100 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  };
  return (
    <div className="Investor3thing">
      <div className="Investor3thing__things__width">
        <div className="Investor3thing__things">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.01 }}
            variants={fadeInUp}
          >
            <div className="Investor3thing__thing__section">
              <img src={investoricon1} alt="Luxury villa with sea view in Costa Blanca, Spain" />
              <h3>high returns</h3>
              <p>
                Our projects are designed to maximize investment potential,
                offering attractive returns and long-term value.
              </p>
            </div>
          </motion.div>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.01 }}
            variants={fadeInUp}
          >
            <div className="Investor3thing__thing__section">
              <img src={investoricon2} alt="Luxury villa with sea view in Costa Blanca, Spain" />
              <h3>risk mitigation</h3>
              <p>
                We conduct thorough market research and feasibility studies to
                minimize risks and ensure the success of every project.
              </p>
            </div>
          </motion.div>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.01 }}
            variants={fadeInUp}
          >
            <div className="Investor3thing__thing__section">
              <img src={investoricon3} alt="Luxury villa with sea view in Costa Blanca, Spain" />
              <h3>transparency</h3>
              <p>
                We maintain open and transparent communication with our
                investors, providing regular updates and detailed reports on
                project progress.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Investor3thing;
